import React from "react"
import YoutubeVideo from "components/YoutubeVideo"
import { ACCESS_EMBEDDED_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function HeroSection() {
  const { getAsset } = usePageAssets()
  const background = getAsset("ed-hero-background")
  return (
    <Container className="pb-10 pt-12 lg:pb-32 lg:pt-32" section>
      <div className="relative flex flex-col gap-x-12 gap-y-10 lg:flex-row lg:items-center">
        <div className="w-full lg:w-1/2">
          <Heading
            level="h1"
            title="Deliver embedded dashboards to your team and customers"
            subtitle="Easily integrate and embed analytics directly inside your application, product, or service."
            size="large"
          />
          <Button
            className="mt-6"
            color="green"
            size="medium"
            href={ACCESS_EMBEDDED_URL}
            trackClick="Request Access (hero)_Embedded Dashboards"
            shadow
          >
            Request Access
          </Button>
        </div>
        <div className="w-full lg:w-1/2">
          <YoutubeVideo
            className="overflow-hidden rounded-lg"
            url="https://www.youtube.com/watch?v=AnHEeUtJIlE"
          />
        </div>
        <div className="absolute bottom-0 left-0 -z-1 max-w-[80%] -translate-y-2/3 scale-[3] lg:bottom-auto lg:left-auto lg:right-0 lg:top-1/2 lg:-translate-y-1/2 lg:scale-100">
          <Image src={background} />
        </div>
      </div>
    </Container>
  )
}

export default HeroSection
